import { Container, Dialog } from '@mui/material';
import { useShallow } from 'zustand/react/shallow';

import { useCartStore, useCartStoreActions } from 'services/stores/cart';
import { PageEventFragment } from 'types/api/dato-operations.types';

import Header from 'components/@seating/SeatingDialog/Header';

import Content from './Content';

interface Props {
  event: PageEventFragment;
  onSeatsConfirmed?: (ticketIds: Array<string>) => void;
}

const SeatingDialog = ({ event, onSeatsConfirmed }: Props) => {
  const [seatingInfo, seatingToken] = useCartStore(
    useShallow((state) => [state.seatingInfo, state.seatingToken]),
  );

  const { removeSeatingInfo } = useCartStoreActions();

  const handleClose = () => {
    removeSeatingInfo();
  };

  const handleSubmit = () => {
    const ticketIds =
      seatingInfo?.categories.map((category) => category.ticketId) ?? [];
    removeSeatingInfo();
    onSeatsConfirmed?.(ticketIds);
  };

  if (!seatingInfo) return null;

  return (
    <Dialog open={!!seatingInfo} onClose={handleClose} fullScreen hideBackdrop>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          flex: '1',
        }}
      >
        <Header
          event={event}
          onCloseDialog={handleClose}
          endTime={seatingToken?.expiresAt}
        />

        <Content
          seatingInfo={seatingInfo}
          seatingToken={seatingToken}
          timezone={event.timezone}
          onSubmit={handleSubmit}
        />
      </Container>
    </Dialog>
  );
};

export default SeatingDialog;
